import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import { Box, CircularProgress, IconButton } from '@mui/material';

type SearchEndAdornmentProps = {
  isFetching: boolean;
  searchValue: string;
  handleClear: () => void;
  color?: string;
  size?: number;
};

const styles = {
  spinner: {
    mr: 0.5,
    display: 'inline-flex',
    alignItems: 'center',
  },
  clearButton: {
    color: 'neutral.200',
    '&:hover': {
      color: 'text.primary',
    },
  },
  clearIcon: (size: number) => ({
    fontSize: size,
  }),
  progress: (color: string) => ({
    color,
  }),
} as const;

const SearchEndAdornment = ({
  isFetching,
  searchValue,
  handleClear,
  color = 'primary.main',
  size = 16,
}: SearchEndAdornmentProps) => {
  if (isFetching) {
    return (
      <Box sx={styles.spinner}>
        <CircularProgress size={size} sx={styles.progress(color)} />
      </Box>
    );
  }

  if (searchValue) {
    return (
      <IconButton size='small' sx={styles.clearButton} onClick={handleClear}>
        <ClearRoundedIcon sx={styles.clearIcon(size)} />
      </IconButton>
    );
  }

  return null;
};

export default SearchEndAdornment;
